<div class="confirmation_container">
  <div class="confirmation_container_sub">
    <div class="confirmation_container_inner">
      <div *ngIf="!loading && success" class="successMessage">
        <div class="successIcon">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
          </svg>
        </div>
        <h1>{{ paymentDetails?.object_type === 'setup_intent' ? 'Payment Method Saved' : 'Payment Successful' }}</h1>
        <p>{{ paymentDetails?.object_type === 'setup_intent' ? 'Your payment method has been successfully saved and is ready for future use.' : 'Thank you for your payment. Your transaction has been completed.' }} </p>

        <div class="details">
          <p><strong>{{ paymentDetails?.object_type === 'setup_intent' ? 'Setup ID:' : 'Payment ID:' }}</strong> {{
            paymentDetails?.id }}</p>
          <p *ngIf="perennialStripeUserDetails?.name" class="name"><strong>Name:</strong> {{
            perennialStripeUserDetails.name }}</p>
          <p *ngIf="perennialStripeUserDetails?.email"><strong>Email:</strong> {{ perennialStripeUserDetails.email }}
          </p>

          <p *ngIf="paymentDetails?.object_type === 'payment_intent' && paymentDetails?.amount > 0">
            <strong>Amount:</strong> {{ paymentDetails.amount / 100 | currency:paymentDetails.currency:'symbol':'1.2-2'
            }}
          </p>

          <p><strong>Date:</strong> {{ today }}</p>
        </div>


        <button (click)="gotToDashBoard('/perennial-mandalism-dashboard')" mat-button class="button">
          Go to Dashboard
        </button>
      </div>

      <div *ngIf="!loading && !success" class="errorMessage">
        <div class="errorIconContainer">
          <svg class="error-cross-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="error__circle" cx="26" cy="26" r="25" fill="none" />
            <path class="error__line1" fill="none" d="M16,16 l20,20" />
            <path class="error__line2" fill="none" d="M16,36 l20,-20" />
          </svg>
        </div>
        <h1>{{ message.includes('saved') || message.includes('Setup') || paymentDetails?.object_type === 'setup_intent'
          ? 'Operation Failed' : 'Payment Failed' }}</h1>
        <p id="errorMessageText">{{ message }}</p>
        <button (click)="gotToDashBoard('/perennial-mandalism-dashboard')" mat-button class="button">
          Go to Dashboard
        </button>
      </div>



      <div *ngIf="loading" class="loading-box">
        
        <h1>Processing</h1>
        <p>Please wait while we confirm your details.</p>
      </div>


    </div>
  </div>
</div>